const APP_ROUTES = {
  success: "/transaction/:transactionId/success",
  progress: "/transaction/:transactionId/progress",
  mainForm: "/transaction/:transactionId",
  transactionError: "/transaction/:transactionId/error",
};

export default APP_ROUTES;
